
export default {
    props: {
        type: {
            type: String,
            default: 'default'
        },
        link: {
            type: String,
            default: '#'
        },
        icon: {
            type: String,
            default: ''
        }
    }
}
